import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type DeleteCheckPartsInput = {
  logId: number;
  itemId: number;
  partId: number;
};

export const useDeleteCheckPartsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.deleteVhcRecordsItemsChecksParts>>,
      QueryError,
      DeleteCheckPartsInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ logId, itemId, partId }: DeleteCheckPartsInput) => {
      return VhcRecordLogService.deleteVhcRecordsItemsChecksParts(logId, itemId, partId);
    },
    {
      ...options
    }
  );
